
















































































































































import SelectPanel from '../select-panel/index.vue';
import { defineComponent, ref, computed, PropType, toRefs, watch } from '@vue/composition-api';
import { debounce } from 'lodash-es';
import { PixelStatus } from '@ad/tt_ads_common_enums';
import { usePixelListSelectInfiniteScroll } from './use-pixel-list-select-infinite-scroll';
import SelectListOperator from '../select-list-operator/index.vue';
import { trackEvent } from './../../../utils/index';
import { PixelInfo, AdgroupFormData } from '@tt4b/ttam-enums';
import { useStore } from '@tt4b/ttam-hooks';

interface ListItem {
  name: string;
  id: string;
  disabled?: boolean;
}

export default defineComponent({
  name: 'PixelListSelectInfiniteScroll',
  components: {
    SelectPanel,
    SelectListOperator,
  },
  props: {
    // 埋点事件
    dataTeaName: {
      type: String,
      default: '',
    },
    dataTeaClick: {
      type: String,
      default: '',
    },
    dataTeaDelete: {
      type: String,
      default: '',
    },
    dataTeaSelect: {
      type: String,
      default: '',
    },
    dataTeaListEventName: {
      type: String,
      default: '',
    },

    propId: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 用于回填的 Pixel 显示
    preloadedPixelList: {
      type: Array as PropType<ListItem[]>,
      default: () => [],
    },

    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },

    handleItemDisabled: {
      type: Function as PropType<(item: PixelInfo & ListItem) => boolean>,
      default: () => false,
    },

    alwaysFetchOffSite: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { handleItemDisabled, adgroupData, alwaysFetchOffSite } = toRefs(props);

    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value.aadvid);

    const popperVisible = ref(false);

    const isSelected = item => String(item.id) === String(props.propId);

    const isItemDisabled = item => {
      if (Object.prototype.hasOwnProperty.call(item, 'disabled')) {
        return item.disabled;
      } else {
        return handleItemDisabled.value?.(item);
      }
    };

    const selectedItem = ref({ id: '', name: '' });
    const onSelectItem = (item, disable = false) => {
      if (!disable) {
        popperVisible.value = false;
        emit('update', {
          ...item,
        });
        selectedItem.value = { ...item };

        if (props.dataTeaSelect) {
          trackEvent(props.dataTeaSelect);
        }
      }
    };

    const goToPixel = () => {
      const link = `${window.location.origin}/i18n/events_manager/pixel?aadvid=${aadvid.value}`;
      window.open(link, '_blank');
    };

    const onClearSelected = () => {
      if (props.disabled) {
        return false;
      }

      emit('update', {});

      if (props.dataTeaDelete) {
        trackEvent(props.dataTeaDelete);
      }
    };

    const {
      refresh,
      loadNextPage,

      searchKeyword,
      loadedPixelList,

      isFirstPageLoading,
      isInfiniteScrollLoading,
      isFirstPageError,
      isNextPageError,
    } = usePixelListSelectInfiniteScroll(adgroupData, alwaysFetchOffSite);

    watch(
      searchKeyword,
      debounce(() => refresh(), 300, { leading: true, maxWait: 500 }),
    );

    const selectedName = computed(() => {
      const { propId } = props;

      return (
        [selectedItem.value, ...props.preloadedPixelList, ...loadedPixelList.value].find(
          item => `${item?.id}` === `${propId}`,
        )?.name || ''
      );
    });

    return {
      aadvid,
      popperVisible,
      PixelStatus,
      selectedName,
      isSelected,
      isItemDisabled,

      onSelectItem,
      goToPixel,
      onClearSelected,

      refresh,
      loadNextPage,
      searchKeyword,

      loadedPixelList,
      isFirstPageError,
      isNextPageError,
      isFirstPageLoading,
      isInfiniteScrollLoading,
    };
  },
});
